module.exports = __webpack_public_path__ + "static/media/IB_core_tok.961ad5da.png";